import { createSlice } from '@reduxjs/toolkit';

import { IStudyState } from 'src/features/study/domain/types';

import { STUDY_LOADING_KEY, getStudyDetails } from './studyThunks';

const initialState: IStudyState = {
	studyDetails: null,
};

const studySlice = createSlice({
	name: STUDY_LOADING_KEY,
	initialState: initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getStudyDetails.fulfilled, (state, action) => {
			state.studyDetails = action.payload;
		});
	},
});

export default studySlice.reducer;
